import { call,delay, put, race, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";

import {
  setLoaderAction,
  setNotificationAction,
  setToastAction,
} from "../reducers/mmymSlice";
import {
  addEmailTemplateAction,
  addSmsTemplateAction,
  deleteEmailTemplateAction,
  getAllEmailTemplatesAction,
  getAllEventsAction,
  getAllSmsTemplatesAction,
  getLeadStageWithPlaceholdersAction,
  leadSendEmailTemplateAction,
  sendEmailTemplateAction,
  sendEmailTemplateResponseAction,
  setAddEmailTemplateFailureAction,
  setAddEmailTemplateSuccessAction,
  setAllEmailTemplatesAction,
  setAllEventsAction,
  setAllSmsTemplatesAction,
  setDeleteEmailTemplateSuccessAction,
  setLeadSendEmailTemplateResponseAction,
  setLeadStageWithPlaceholdersAction,
  updateEmailTemplateAction,
} from "../reducers/emailTemplateSlice";
import { setLoaderMessage } from "../reducers/clientConfirmationSlice";
import { getSingleLeadAction } from "../reducers/leadSlice";


/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getAllEmailTemplatesSaga(payload: any): any {
  yield put(setLoaderAction(true));
  try {
    const {lead_stage} = payload?.payload || {};
    const templates = yield call<any>(
      callAPI,
      {},
      "get",
      `client/preset/emails${lead_stage ? `?lead_stage=${lead_stage}` : ""}`
    );
    console.log("templates-", templates);
    if (templates?.data) {
      yield put(setAllEmailTemplatesAction(templates?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response, [401]);
  }
  yield put(setLoaderAction(false));
}

function* addEmailTemplateSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    console.log("payload", payload);
    const { template_id, ...templateData } = payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      { payload: templateData },
      "post",
      "client/preset/emails"
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddEmailTemplateSuccessAction(true));
      yield put(setAddEmailTemplateFailureAction(false));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    yield put(setAddEmailTemplateSuccessAction(false));
    yield put(setAddEmailTemplateFailureAction(true));
  }
  yield put(setLoaderAction(false));
}

function* updateEmailTemplateSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    console.log("payload", payload);
    const templateId = payload?.payload?.template_id;
    const { template_id, created_at, updated_at, ...templateData } =
      payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      { payload: templateData },
      "put",
      `client/preset/emails/${templateId}`
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddEmailTemplateSuccessAction(true));
      yield put(setAddEmailTemplateFailureAction(false));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    yield put(setAddEmailTemplateSuccessAction(false));
    yield put(setAddEmailTemplateFailureAction(true));
  }
  yield put(setLoaderAction(false));
}

function* getAllSmsTemplateSaga(): any {
  yield put(setLoaderAction(true));
  try {
    const templates = yield call<any>(callAPI, {}, "get", "client/preset/sms");
    console.log("templates-", templates);
    if (templates?.data) {
      yield put(setAllSmsTemplatesAction(templates?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* addSmsTemplateSaga(payload: any): any {}

function* getAllEventsSaga(payload: any): any {
  yield put(setLoaderAction(true));
  try {
    const events = yield call<any>(callAPI, {}, "get", `admin/events?event_used_for=${payload?.payload?.event_used_for}`);
    console.log("events-", events);
    if (events?.data) {
      yield put(setAllEventsAction(events?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* deleteEmailTemplateSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    console.log("action", action?.payload);
    const Id = action.payload?.template_id; // Directly access the payload
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `client/preset/emails/${Id}`
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setDeleteEmailTemplateSuccessAction(true));
      yield put(getAllEmailTemplatesAction({lead_stage:null}));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    yield put(setDeleteEmailTemplateSuccessAction(false));
  }
  yield put(setLoaderAction(false));
}

function* sendEmailTemplateSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  const {
    disclaimer,
    event,
    links,
    placeholders,
    signature,
    signature_option,
    template_id,
    template_name,
    ...newPayload
  } = payload?.payload;
  try {
    console.log("payload", payload);
    const apiResponse = yield call<any>(
      callAPI,
      { payload: newPayload },
      "post",
      "client/preset/send-email"
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(sendEmailTemplateResponseAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    yield put(sendEmailTemplateResponseAction(false));
  }
  yield put(setLoaderAction(false));
}
// get lead stage with placeholders
function* getLeadStageWithPlaceholdersSaga(): any {
  yield put(setLoaderAction(true));
  try {
    const response = yield call<any>(
      callAPI,
      {},
      "get",
      "client/lead-stages"
    );
    console.log("response-", response);
    if (response?.data) {
      yield put(setLeadStageWithPlaceholdersAction(response?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* leadSendEmailTemplateSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  const {leadId, ...newPayload} = payload?.payload;
  try {
    let url = "leads/send-email";
    console.log("payload", payload);
      // 👉 RUN LOADER STEPS WHILE API IS IN PROGRESS
        const { apiResponse } = yield race({
          apiResponse: call(callAPI, { payload: payload?.payload }, "post", url),
          loaderSteps: call(runLoaderSteps, "email"),
        });
 // 🛑 STOP LOADER STEPS IMMEDIATELY WHEN API IS DONE
    yield put(setLoaderMessage(""));
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setLeadSendEmailTemplateResponseAction(true));
       yield put(getSingleLeadAction(leadId));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    yield put(setLeadSendEmailTemplateResponseAction(false));
  }
  yield put(setLoaderAction(false));
   yield put(setLoaderMessage(""));
}

// 👉 separate saga only for loader animation
function* runLoaderSteps(type: any) {
  if (!["email", "pdf", "odt","previous"].includes(type)) return;

  yield put(setLoaderMessage("Validating confirmation data..."));
  yield delay(3000);

  yield put(setLoaderMessage("Generating ODT template..."));
  yield delay(2000);

  yield put(setLoaderMessage("Converting to PDF..."));
  yield delay(8000);

  yield put(setLoaderMessage("Uploading to secure storage..."));
  yield delay(2000);
}

export function* watchEmailTemplate() {
  yield takeLatest<any>(getAllEmailTemplatesAction, getAllEmailTemplatesSaga);
  yield takeLatest<any>(addEmailTemplateAction, addEmailTemplateSaga);
  yield takeLatest<any>(getAllSmsTemplatesAction, getAllSmsTemplateSaga);
  yield takeLatest<any>(addSmsTemplateAction, addSmsTemplateSaga);
  yield takeLatest<any>(getAllEventsAction, getAllEventsSaga);
  yield takeLatest<any>(updateEmailTemplateAction, updateEmailTemplateSaga);
  yield takeLatest<any>(deleteEmailTemplateAction, deleteEmailTemplateSaga);
  yield takeLatest<any>(sendEmailTemplateAction, sendEmailTemplateSaga);
  yield takeLatest<any>(getLeadStageWithPlaceholdersAction, getLeadStageWithPlaceholdersSaga);
  yield takeLatest<any>(leadSendEmailTemplateAction, leadSendEmailTemplateSaga);
}
